import { createSelector } from '@reduxjs/toolkit';

import { entityDrawerSelector } from 'src/selectors/entityDrawer';
import { memoizeSelectorFactory } from 'src/selectors/memoizeSelectorFactory';
import { projectAttributesByIriSelector } from 'src/selectors/projectAttributesByIri';

export const entityDrawerAttributeDataSelector = memoizeSelectorFactory(
  (projectId: string) =>
    createSelector(
      entityDrawerSelector,
      projectAttributesByIriSelector(projectId),
      (drawer, attributesByIri) =>
        drawer.entityValue ? attributesByIri[drawer.entityValue] || null : null
    )
);
